import {
  __PARTIAL__APP_CREW_SCHEDULE,
  __PARTIAL__APP_READONLY_SCHEDULE,
  APP_CREW_SCHEDULE,
  APP_CREW_SCHEDULE_VIEWONLY
} from '../_constants/permissions'
import { NotAllowed } from '../_features/NotAllowed'
import { SeasonSectionsOverview } from '../_features/SeasonSectionsOverview'
import { useMyself } from '../_features/UserContext'
import { SingleColumn } from '../_layout/content'
import { MainContainer } from '../_ui'

type PropTypes = {
  pageLink: string
}

export const SeasonSectionsOverviewPage = ({ pageLink }: PropTypes) => {
  const { canAccess } = useMyself() || {}

  if (!canAccess || (
    !canAccess(APP_CREW_SCHEDULE)
    && !canAccess(APP_CREW_SCHEDULE_VIEWONLY)
    && !canAccess(__PARTIAL__APP_CREW_SCHEDULE)
    && !canAccess(__PARTIAL__APP_READONLY_SCHEDULE)
  )) {
    return (
      <NotAllowed />
    )
  }

  return (
    <SingleColumn>
      <MainContainer>
        <SeasonSectionsOverview
          backButton
          baseLink={pageLink}
        />
      </MainContainer>
    </SingleColumn>
  )
}
